const ESTIMATED_PROCESSING_FEE_RATE = 0.051;
const ESTIMATED_PROCESSING_FIXED_FEE_CENTS = 30;

export function calculateEstimatedProcessingFeeCents(amountCents: number): number {
  if (!Number.isFinite(amountCents) || amountCents <= 0) {
    return 0;
  }

  return Math.max(
    0,
    Math.round(amountCents * ESTIMATED_PROCESSING_FEE_RATE) + ESTIMATED_PROCESSING_FIXED_FEE_CENTS,
  );
}

export function calculateEstimatedNetToMissionCents(amountCents: number): number {
  if (!Number.isFinite(amountCents) || amountCents <= 0) {
    return 0;
  }

  return Math.max(0, amountCents - calculateEstimatedProcessingFeeCents(amountCents));
}

export function calculateCoveredTotalCents(baseAmountCents: number): number {
  if (!Number.isFinite(baseAmountCents) || baseAmountCents <= 0) {
    return 0;
  }

  let grossAmountCents = baseAmountCents;
  while (calculateEstimatedNetToMissionCents(grossAmountCents) < baseAmountCents) {
    grossAmountCents += 1;
  }

  return grossAmountCents;
}

export function calculateCoveredFeeCents(baseAmountCents: number): number {
  if (!Number.isFinite(baseAmountCents) || baseAmountCents <= 0) {
    return 0;
  }

  return Math.max(0, calculateCoveredTotalCents(baseAmountCents) - baseAmountCents);
}
